<template>
	<div class="flexCol alit">
		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E7%81%AB%E9%94%85%E4%BA%A7%E4%B8%9A/%E7%81%AB%E9%94%85.png"
			alt="" />
		<div class="flex alit justc">
			<img style="width: 30%;"
				src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E7%81%AB%E9%94%85%E4%BA%A7%E4%B8%9A/WPS%E5%9B%BE%E7%89%87%281%29.png"
				alt="" />
			<img style="width: 30%;margin: 0 20px;"
				src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E7%81%AB%E9%94%85%E4%BA%A7%E4%B8%9A/WPS%E5%9B%BE%E7%89%87%282%29.png"
				alt="" />
			<img style="width: 30%;"
				src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E7%81%AB%E9%94%85%E4%BA%A7%E4%B8%9A/WPS%E5%9B%BE%E7%89%87%283%29.png"
				alt="" />
		</div>
		<div class="desc" style="margin-top: 20px;">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;重庆火锅产业要素交易平台在国家乡村振兴和产业数字化战略下，由重庆市政府主导，重庆市商务委牵头渝中区政府与重庆火锅产业协会共同打造，联合国内知名火锅企业、食材基地、供应链企业和金融主体参与共建的火锅全要素平台，致力于推进一二三产深度融合，构建引领全球、融合高效的现代火锅产业体系，实现“让全球每个人都吃上安全健康的火锅食材’之初心。
		</div>
		<div class="desc">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;重庆火锅产业要素交易平台总部展厅位于重庆渝中区环球金融中心13层，链接重庆火锅产业协会1700家企业会员、本土1.6万家火锅企业和3.9万家火锅门店，为全国20多万家重庆火锅品牌门店和50多万家地方火锅品牌门店提供服务，2024年重庆火锅全产业链实现3700亿产值和800亿门店营收，全力打造全球火锅食材交易中心、全国火锅标准制定发布中心、火锅美食文化创新交流中心和火锅产业大数据中心。
		</div>
		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">交易平台核心战略</div>
		<img style="width: 70%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E7%81%AB%E9%94%85%E4%BA%A7%E4%B8%9A/%E7%81%AB%E9%94%85%E5%B9%B3%E5%8F%B0.png"
			alt="" />
		<div class="desc" style="margin: 20px 0;">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;重庆火锅产业要素交易平台探索“种养殖基地+供应链金融+火锅门店”模式，严把食品原料准入关和进货查验，推广重庆火锅溯源码，评定五星级绿色餐厅和5A级供应商，数字化赋能全产业链，推动火锅产业量质齐升，力争2027年实现重庆”33618“集群的火锅全产业链目标5000亿。
		</div>
		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">业务模式</div>
		<img style="width: 80%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E7%81%AB%E9%94%85%E4%BA%A7%E4%B8%9A/WPS%E5%9B%BE%E7%89%87%284%29.png"
			alt="" />
		<img style="width: 80%;margin: 10px 0;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E7%81%AB%E9%94%85%E4%BA%A7%E4%B8%9A/%E5%B9%B3%E5%8F%B0%E6%9C%8D%E5%8A%A1.png"
			alt="" />
	</div>
</template>

<script>
</script>

<style scoped>
	.sj-cont {
		width: 24%;
		background-color: rgb(12 84 166);
		color: #fff;
		height: 50px;
		text-align: center;
		line-height: 50px;
		font-size: 24px;
		margin-top: 10px;
	}

	.desc {
		width: 90%;
		font-size: 24px;
	}

	img {
		width: 100%;
	}

	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 20px 0;
		color: rgb(86 146 48);
	}

	.title-desc {
		text-align: center;
		font-size: 17px;
		color: rgb(151 151 151);
		margin-bottom: 20px;
	}
</style>